module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-12.a0341c24.png";